<template>
  <material-card
    :text="title"
    :color="colorCard">

    <GChart
      :ref="ref"
      :data="data"
      :options="options"
      type="ColumnChart"
    />
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="primary"
        flat
        small
        @click="salvarGrafico(ref)"
      >
        <v-icon
          left
          dark>mdi-content-save</v-icon>
        {{ strings[idioma].salvar }}
      </v-btn>
    </v-card-actions>
  </material-card>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    title: '',
    data: {},
    options: {},
    ref: ''
  },
  computed: {
    ...mapState('app', ['strings', 'coords', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas', 'vinculados', 'alimentos_empresa', 'map']),
    colorCard () {
      return 'indigo lighten-5'
    }
  },
  methods: {
    salvarGrafico (ref) {
      const chart = this.$refs[ref].chartObject
      var imgUri = chart.getImageURI()
      var url = imgUri.replace(/^data:image\/[^;]+/, 'data:application/octet-stream')
      let link = document.createElement('a')
      link.href = url
      link.download = 'graph' + new Date().getTime() + '.png'
      link.target = '_blank'
      link.click()
    }
  }
}
</script>
